import { Content } from '../../types';

export const hanoiTrainStreetAndTrainNightMarketContent: Content = {
  title: 'רחוב הרכבת בהאנוי ושוק הרכבת בתאילנד - חוויות מסילה שלא תרצו לפספס!',
  imageUrl: '/images/common/train-night-market/train-night-market-wide.jpeg',
  introduction:
    'אם אתם מחפשים חווייה יוצאת דופן המשלבת תרבות מקומית, מתחמי בילוי תוססים ואדרנלין של רכבת שעוברת ממש לצידכם - שני המקומות האלו הינם חובה בביקור בוייטנאם ובתאילנד! אבל מה המשותף להם ומה ההבדלים ביניהם?',
  sections: [
    {
      title: 'רחוב הרכבת בהאנוי, וייטנאם',
      content:
        'ברובע העתיק של האנוי תמצאו את אחד מאתרי הבילוי הייחודיים ביותר בעיר - רחוב הרכבת. זוהי סמטא צרה השוקקת חיים עם בתי קפה ומסעדות קטנות, שבהן האורחים יושבים ממש לצד מסילת הרכבת. בכל פעם שהרכבת מתקרבת, בעלי העסקים ממהרים לקפל שולחנות וכיסאות, מפנים את הדרך - ותוך שניות מסיום מעברה של הרכבת, הכל חוזר לשגרה כאילו לא קרה דבר!<br /><strong>מתי הרכבת עוברת?</strong> מספר פעמים ביום - בעיקר בערב, אך בסופי שבוע גם בשעות הבוקר.<br /><strong><br /><strong>מה מיוחד כאן?</strong></strong> חלק מבתי הקפה מציעים קומה שנייה, vמאפשרת תצפית מצוינת על הרכבת, לצד קפה וייטנאמי חזק.',
      type: 'text',
    },
    {
      title: 'שוק הרכבת בתאילנד, Talat Rom Hub',
      content:
        'לעומת זאת, שוק הרכבת בתאילנד, הממוקם על מסילת הרכבת סמוך לתחנת Maeklong במחוז Samut Songkhram, הוא שוק מקומי מסורתי למכירת פירות, ירקות, דגים, פירות ים ועוד. המיוחד כאן הינו הדרך שבה המוכרים מקפלים במהירות את הסחורה והסככות עם כל מעבר של הרכבת - 8 פעמים ביום! ברגע שהרכבת חולפת, הם פורשים הכל מחדש, כאילו לא קרה דבר.<br /><strong>מתי הרכבת עוברת?</strong> השוק פעיל כל היום, אך הרכבת חולפת 8 פעמים ביום - מומלץ לבדוק את השעות מראש כדי לתפוס את הרגע הדרמטי!<br /><strong>מה מיוחד כאן?</strong> חוויה אותנטית של שוק תאילנדי, המשלבת חיי יום-יום של המקומיים עם מחזה מרהיב של רכבת החוצה אותו.',
      type: 'text',
    },
    {
      title: 'מה משותף ומה שונה?',
      content:
        '<strong>משותף: </strong>בשני המקומות חווים תופעה ייחודית ובלתי רגילה - מסילת רכבת המשתלבת בחיי היומיום, בין אם כמתחם בילוי ובין אם כשוק מסורתי.<br /><strong>שונה: </strong> רחוב הרכבת בהאנוי הינו מקום בילוי תיירותי עם בתי קפה ואווירה רגועה ואילו השוק בתאילנד הינו שוק מסורתי הומה אדם, שבו הדגש הוא על המסחר והחוויה האותנטית.',
      type: 'text',
    },
    {
      title: 'למי זה מתאים?',
      content: [
        'חובבי קניות ושווקים? שוק הרכבת בתאילנד הינו עבורכם.',
        'רוצים לשבת בכיף עם משקה ביד ולחכות לרכבת? רחוב הרכבת בהאנוי הינו המקום המושלם.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content:
        'לא משנה איזה מקום תבחרו, חוויית הרכבת תהיה בלתי נשכחת! מומלץ מאוד לשלב אותה בטיול שלכם.',
      type: 'text',
    },
  ],
};
